import type { ApiClient, SourceMaterial } from "./api";
import { useLoaded } from "./useLoaded";

/** How many rows "Recently added" shows in the navigator panel. */
const RECENT_LIMIT = 10;

const readRecent = (api: ApiClient) => api.listSources(RECENT_LIMIT);

/**
 * The capture pages' "Recently added" list.
 *
 * Loaded once and refreshed on demand rather than polled: the only thing that changes
 * it is the owner adding a source, and that is a moment this app knows about. A failure
 * is not reported — the panel showing nothing is a small loss next to an error banner
 * over a screen whose actual job worked.
 */
export function useRecentSources(api: ApiClient): {
  recentSources: SourceMaterial[];
  refreshRecentSources: () => void;
} {
  const { value, refresh } = useLoaded(api, readRecent, [] as SourceMaterial[], "");

  return { recentSources: value, refreshRecentSources: refresh };
}
